
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/teachers/curriculum/[subjectPhaseSlug]/[...slugs]",
      function () {
        return require("private-next-pages/teachers/curriculum/[subjectPhaseSlug]/[...slugs].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/teachers/curriculum/[subjectPhaseSlug]/[...slugs]"])
      });
    }
  